import { MainMenu, SubMenuType } from 'rangeConfig/@types';
import ProductSwiper from 'rangeConfig/shared/widgets/ProductSwiper';
import FrontLayouts from 'rangeConfig/smastad/widgets/FrontLayouts';
import checkWidget from 'rangeConfig/shared/widgets/checkWidget';
import showDoors from 'rangeConfig/shared/behaviors/showDoors';
import withProducts from 'rangeConfig/shared/widgets/withProducts';
import { frontsProductListConfig } from './productListConfig';
import platform from 'rangeConfig/shared/utils/platform';
import ProductList from 'rangeConfig/shared/widgets/ProductList';
import forgetFrontChangeUserChoices from 'rangeConfig/shared/behaviors/forgetFrontChangeUserChoices';
import withErrorMessage from 'rangeConfig/shared/widgets/withErrorMessage';
import {
  getNoFramesInSceneErrorMessage,
  getSmastadAddingToFramesWithIncludedDoorsErrorMessage,
  getSmastadAddingToMixedFramesWithIncludedDoorsErrorMessage
} from 'rangeConfig/shared/utils/errorMessages';
import ErrorMessageInline from 'rangeConfig/shared/widgets/ErrorMessageInline';
import { CoreApi } from '@inter-ikea-storageone/range';
import { hideNoFramesInSceneErrorMessage } from 'rangeConfig/shared/rules/hideMenuRules';
import {
  hideSmastadAllFramesIncludedDoorsErrorMessage,
  hideSmastadMixedFramesIncludedDoorsErrorMessage
} from 'rangeConfig/smastad/rules/hideMenuRules';
import {
  sortByName,
  sortByPriceAscending,
  sortByPriceDescending
} from 'rangeConfig/shared/sorting/sortingConfigs';
import ProductSortFilterWidget from 'rangeConfig/shared/widgets/ProductSortFilterWidget';

const widgets = {
  desktop: [
    {
      id: 'error-message-no-frames-in-scene',
      component: withErrorMessage(getNoFramesInSceneErrorMessage)(ErrorMessageInline),
      hidden: (coreApi: CoreApi) => hideNoFramesInSceneErrorMessage(coreApi)
    },
    {
      id: 'error-message-frames-in-scene-included-doors',
      component: withErrorMessage(getSmastadAddingToFramesWithIncludedDoorsErrorMessage)(
        ErrorMessageInline
      ),
      hidden: (coreApi: CoreApi) => hideSmastadAllFramesIncludedDoorsErrorMessage(coreApi)
    },
    {
      id: 'error-message-some-frames-in-scene-included-doors',
      component: withErrorMessage(getSmastadAddingToMixedFramesWithIncludedDoorsErrorMessage)(
        ErrorMessageInline
      ),
      hidden: (coreApi: CoreApi) => hideSmastadMixedFramesIncludedDoorsErrorMessage(coreApi)
    }
  ],
  mobile: [
    {
      id: 'fronts-style-product-swiper',
      component: withProducts(ProductSwiper, frontsProductListConfig),
      title: 'storageone.frontStyleTabTitle'
    },
    {
      id: 'fronts-layout-layout',
      component: checkWidget(FrontLayouts),
      title: 'storageone.frontLayoutTabTitle'
    }
  ]
};

const subMenu = {
  desktop: {
    type: SubMenuType.TABS,
    options: [
      {
        id: 'front-style-tab',
        title: 'storageone.frontStyleTabSelectedMenuTitle',
        sorting: [sortByName, sortByPriceAscending, sortByPriceDescending],
        widgets: [
          {
            id: 'fronts-sort-filter-widget',
            component: ProductSortFilterWidget
          },
          {
            id: 'front-style-list',
            component: withProducts(ProductList, frontsProductListConfig)
          }
        ]
      },
      {
        id: 'front-combinations-tab',
        title: 'storageone.combinationsTabTitle',
        widgets: [
          {
            id: 'front-layout-list',
            component: checkWidget(FrontLayouts)
          }
        ]
      }
    ]
  },
  mobile: undefined
};

const mainMenu: MainMenu = {
  menuTitle: 'storageone.productListFrontsTitle',
  behaviors: {
    productGroupEntered: [showDoors],
    productGroupExited: [forgetFrontChangeUserChoices]
  },
  widgets: widgets[platform],
  subMenu: subMenu[platform]
};

export default mainMenu;
